import { updateListMethod } from '../../utils/list'
import {
  TENANT_UPDATE_TENANT,
  TENANT_UPDATE_TENANT_BASIC_INFORMATION,
  TENANT_UPDATE_YEARS_LIST,
  TENANT_UPDATE_YEARS_LIST_METHOD,
  TENANT_UPDATE_ANALYTICS_CHARTS_LIST,
  TENANT_UPDATE_ANALYTICS_CHARTS_LIST_METHOD,
  TENANT_UPDATE_API_SERVICES_LIST,
  TENANT_UPDATE_API_SERVICES_LIST_METHOD,
  TENANT_UPDATE_TERM_LIST,
  TENANT_UPDATE_TERM_LIST_METHOD,
  TENANT_UPDATE_TERM_ACTIVE,
  TENANT_UPDATE_SSO_LIST,
  TENANT_UPDATE_SSO_LIST_METHOD,
  TENANT_UPDATE_FLAGS_LIST,
  TENANT_UPDATE_FLAGS_LIST_METHOD,
  TENANT_UPDATE_FEATURE_FLAG,
  TENANT_UPDATE_GEO,
  TENANT_UPDATE_THIRD_PARTY_ACCESS_LIST,
  TENANT_UPDATE_THIRD_PARTY_ACCESS_LIST_METHOD
} from '../actions/tenant.actions'

const initialState = {
  loading: false,
  timezone: 'Australia/Victoria',
  tenant: {},
  license: [],
  curriculum: [],
  sso: [],
  years: [],
  terms: [],
  analyticsCharts: [],
  apiServices: [],
  termActive: {},
  flags: [],
  thirdPartyAccess: [],
  featureFlag: {},
  featureFlagMeta: {}
}

const tenantReducer = (state = initialState, action) => {
  const newState = { ...state }
  const { type, payload } = action

  switch (type) {
    case TENANT_UPDATE_TENANT: {
      const { data } = payload
      newState.tenant = {
        date: data.date,
        address: data.address,
        email: data.email,
        licenseId: data.licenseId,
        curriculumId: data.curriculumId,
        logo: data.logo,
        logoUrl: data.logoUrl,
        name: data.name,
        timezone: data.timezone,
        url: data.url,
        domain: data.domain,
        tenantId: data.tenantId,
        schoolId: data.schoolId,
        hideName: data.hideName || false,
        hideAddress: data.hideAddress || false,
        isUnderMaintenance: data.isUnderMaintenance || false,
        featureFlag: data.featureFlag || {}
      }
      const serializedTenantData = JSON.stringify(newState.tenant)
      localStorage.setItem('tenantData', serializedTenantData)
      localStorage.setItem('timezone', data.timezone)
      newState.timezone = data.timezone
      newState.curriculum = data.curriculum || []
      newState.license = data.license || []
      newState.sso = data.sso || []
      newState.featureFlag = data.featureFlag || {}
      newState.featureFlagMeta = data.featureFlagMeta || {}

      break
    }

    case TENANT_UPDATE_TENANT_BASIC_INFORMATION: {
      newState.tenant = {
        ...newState.tenant,
        name: payload.data.name,
        address: payload.data.address,
        schoolId: payload.data.schoolId,
        hideName: payload.data.hideName || false,
        hideAddress: payload.data.hideAddress || false,
        timezone: payload.data.timezone
      }
      const serializedTenantDatat = JSON.stringify(newState.tenant)
      localStorage.setItem('tenantData', serializedTenantDatat)
      localStorage.setItem('timezone', payload.data.timezone)
      newState.timezone = payload.data.timezone
      break
    }
    case TENANT_UPDATE_GEO: {
      newState.tenant = { ...newState.tenant, geo: payload.geo }
      localStorage.setItem('tenantData', JSON.stringify(newState.tenant))
      break
    }
    case TENANT_UPDATE_YEARS_LIST:
      newState.years = payload.data
      break
    case TENANT_UPDATE_YEARS_LIST_METHOD:
      newState.years = updateListMethod(payload.method, payload.data, newState.years)
      break
    case TENANT_UPDATE_ANALYTICS_CHARTS_LIST:
      newState.analyticsCharts = payload.data
      break
    case TENANT_UPDATE_ANALYTICS_CHARTS_LIST_METHOD:
      newState.analyticsCharts = updateListMethod(payload.method, payload.data, newState.analyticsCharts)
      break
    case TENANT_UPDATE_API_SERVICES_LIST:
      newState.apiServices = payload.data
      break
    case TENANT_UPDATE_API_SERVICES_LIST_METHOD:
      newState.apiServices = updateListMethod(payload.method, payload.data, newState.apiServices)
      break
    case TENANT_UPDATE_TERM_LIST:
      newState.terms = payload.data
      break
    case TENANT_UPDATE_TERM_LIST_METHOD:
      newState.terms = updateListMethod(payload.method, payload.data, newState.terms)
      break
    case TENANT_UPDATE_SSO_LIST:
      newState.sso = payload.data
      break
    case TENANT_UPDATE_SSO_LIST_METHOD:
      newState.sso = updateListMethod(payload.method, payload.data, newState.sso)
      break
    case TENANT_UPDATE_TERM_ACTIVE:
      newState.termActive = payload.data
      break
    case TENANT_UPDATE_FLAGS_LIST:
      newState.flags = payload.data
      break
    case TENANT_UPDATE_FLAGS_LIST_METHOD:
      newState.flags = updateListMethod(payload.method, payload.data, newState.flags)
      break
    case TENANT_UPDATE_FEATURE_FLAG:
      newState.featureFlag = payload.data
      if (payload.meta !== undefined) newState.featureFlagMeta = payload.meta
      break
    case TENANT_UPDATE_THIRD_PARTY_ACCESS_LIST:
      newState.thirdPartyAccess = payload.data
      break
    case TENANT_UPDATE_THIRD_PARTY_ACCESS_LIST_METHOD:
      newState.thirdPartyAccess = updateListMethod(payload.method, payload.data, newState.thirdPartyAccess)
      break
    default:
      break
  }
  return newState
}
export default tenantReducer
